import axios from "axios";
import toast from "react-hot-toast";
import { getToken } from "./token";
const controller = new AbortController();

const instance = axios.create({
  // baseURL: process.env.REACT_APP_API_URL_VOLTZ,
  // baseURL: process.env.REACT_APP_API_URL_AMPERE,
  // baseURL: "https://api.mms.ampere.plus/",
  baseURL: "https://api.app.chanels.io/",
});

instance.interceptors.request.use(async (config) => {
  try {
    let token = await getToken("spiral_token");
    let username = await getToken("spiral_username");
    // console.log(config, "config object");
    config.headers["Version"] = "0.1";
    if (config.data) {
      config.data.sessionid = token;
      config.data.callerid = username;
    }
    config.signal = controller.signal;
    return config;
  } catch (err) {
    toast.error(err);
  }
});

instance.interceptors.response.use(
  (response) => {
    // console.log(response, "line 27");
    return response;
  },
  (err) => {
    // localStorage.clear();

    if (err.response && err.response.status == 403) {
      // redirect to login page
      // console.log("Got here");
      // return (window.location.href = "/");
    }

    if (err.response && err.response.status == 401) {
      // redirect to login page
      // console.log("Got here");
      // return (window.location.href = "/");
    }

    if (err.response && err.response.status >= 500) {
      // interval server error
      // console.log(err.response, "line controller");
      // window.location.href = "/servererror";
    }

    if (err.response && err.response.code == "ERR_NETWORK") {
      // interval server error
      // console.log(err.response, "line controller");
      // window.location.href = "/";
    }
    // console.log(err.message, "line 36");
    return Promise.reject(err);
  }
);

export default instance;
